import { PropsWithChildren, useContext } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { AuthContext } from "./authContext/AuthContext";
import Loading from "../ui/loading/Loading";
import { buildLoginRedirectPath } from "../../helpers/auth-session.helpers";

function PrivateRoute(props: PropsWithChildren) {
    const { auth, authReady } = useContext(AuthContext)
    const location = useLocation()

    if (!authReady) {
        return <Loading />
    }

    if (!auth) {
        return (
            <Navigate
                to={buildLoginRedirectPath(
                    `${location.pathname}${location.search}${location.hash}`
                )}
                replace
            />
        )
    }

    return props.children
}

export default PrivateRoute
